<!-- @format -->

<template>
	<div class="calc-pdf-document">
		<CalcPdfCoverPage
			ref="coverPage"
			:locale="locale"
		/>
		<CalcPdfCalculationPage
			ref="calculationPage"
			:calculation-data="calculationData"
			:locale="locale"
		/>
	</div>
</template>

<script>
import CalcPdfCoverPage from './CalcPdfCoverPage.vue'
import CalcPdfCalculationPage from './CalcPdfCalculationPage.vue'

export default {
	name: 'CalcPdfDocument',

	components: {
		CalcPdfCoverPage,
		CalcPdfCalculationPage,
	},

	props: {
		calculationData: {
			type: Object,
			required: true,
		},
		locale: {
			type: String,
			default: 'en-GB',
		},
	},

	methods: {
		getPageElements() {
			return [this.$refs.coverPage.$el, this.$refs.calculationPage.$el]
		},
	},
}
</script>

<style scoped>
.calc-pdf-document {
	position: absolute;
	left: -10000px;
	top: 0;
	pointer-events: none;
}
</style>
